import crud from './helpers/crud';

const getOrganizationTeams = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ALL_TEAMS',
      fail: 'FAILED_GET_ALL_TEAMS',
      end: 'FINISHED_GET_ALL_TEAMS',
    },
    method: 'GET',
    url: '/api/v1/teams',
  })
);

const createTeam = (teamObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_TEAM',
      fail: 'FAILED_CREATE_TEAM',
      end: 'FINISHED_CREATE_TEAM',
    },
    method: 'POST',
    data: { team: teamObject },
    url: '/api/v1/teams',
  })
);

const updateTeam = (slug, teamObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_TEAM',
      fail: 'FAILED_UPDATE_TEAM',
      end: 'FINISHED_UPDATE_TEAM',
    },
    method: 'PUT',
    data: { team: teamObject },
    url: `/api/v1/teams/${slug}`,
  })
);

const deleteTeam = (slug) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_TEAM',
      fail: 'FAILED_DELETE_TEAM',
      end: 'FINISHED_DELETE_TEAM',
    },
    method: 'DELETE',
    url: `/api/v1/teams/${slug}`,
  })
);

const getTeamUsers = (query = '') => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEAM_USERS',
      fail: 'FAILED_GET_TEAM_USERS',
      end: 'FINISHED_GET_TEAM_USERS',
    },
    method: 'GET',
    url: `/api/v1/team_users${query}`,
  })
);

// Per-user, per-team notification opt-out (D5). index lists the caller's own
// memberships with each team's receives_notifications flag; update PATCHes a
// single membership. Both are gated server-side by the `teams` feature.
const getTeamNotificationPreferences = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEAM_NOTIFICATION_PREFERENCES',
      fail: 'FAILED_GET_TEAM_NOTIFICATION_PREFERENCES',
      end: 'FINISHED_GET_TEAM_NOTIFICATION_PREFERENCES',
    },
    method: 'GET',
    url: '/api/v1/team_notification_preferences',
  })
);

const updateTeamNotificationPreference = (slug, receivesNotifications) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_TEAM_NOTIFICATION_PREFERENCE',
      fail: 'FAILED_UPDATE_TEAM_NOTIFICATION_PREFERENCE',
      end: 'FINISHED_UPDATE_TEAM_NOTIFICATION_PREFERENCE',
    },
    method: 'PATCH',
    url: `/api/v1/team_notification_preferences/${slug}`,
    data: {
      team_notification_preference: {
        receives_notifications: receivesNotifications,
      },
    },
  })
);

export {
  getOrganizationTeams,
  createTeam,
  updateTeam,
  deleteTeam,
  getTeamUsers,
  getTeamNotificationPreferences,
  updateTeamNotificationPreference,
};
